import React, { Component } from "react";
import styled from "styled-components";
import * as styles from "./PageHeader.less";

const Title = styled.h1`
  font-size: 2.5em;
  text-align: center;
  color: #34495e;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-variant: normal;
  font-weight: bold;
  line-height: 26px;
`;
const SubTitle = styled.h1`
  font-size: 1.2em;
  text-align: center;
  color: #eb4b2e;
  font-weight: bold;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
`;
const Wrapper = styled.section`
  background: white;
  width: 100;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Divider = styled.hr`
  border: 0;
  height: 5px;
  width: 80%;
  background-image: linear-gradient(
    to right,
    rgba(235, 75, 46, 0),
    #eb4b2e,
    rgba(235, 75, 46, 0)
  );
`;

class PageHeader extends Component {
  render() {
    return (
      <Wrapper>
        <img
          style={{
            width: 150,
            height: 150
          }}
          src={this.props.image}
        />
        <Title>{this.props.title}</Title>
        <Divider />
        <Wrapper>
          <SubTitle>{this.props.subTitle}</SubTitle>
        </Wrapper>
      </Wrapper>
    );
  }
}

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader.js